import api from '../axios';
import { PREFIX, VERSION } from '../enums/request';

export default class DontDisturbResource {
  static fetchFiles() {
    return api.get(`/${PREFIX.PARTNERS}/${VERSION.V2}/payrollloanproposals/dontdisturb/files`);
  }
}
